export const auctions = [
  {
    title: 'NYG vs. DEN',
    linkTitle: 'Sun, 9/12 vs. DEN',
    meta: ['Game 1', '09/12/2021'],
    imgSrc: 'https://img.granted.co/1620981342529-sqon-nft.jpg',
    packages: [
      {
        imgSrc: '/nft/jersey.png',
        title: 'THE JERSEY PACKAGE',
        link: 'https://granted.co/experiences/551-the-jersey-package-den-vs-nyg',
      },
      {
        imgSrc: '/nft/cleat.png',
        title: 'THE CLEAT PACKAGE',
        link: 'https://granted.co/experiences/550-the-cleat-package-den-vs-nyg',
      },
      {
        imgSrc: '/nft/football.png',
        title: 'THE FOOTBALL PACKAGE',
        link: 'https://granted.co/experiences/549-the-football-package-den-vs-nyg',
      },
    ],
    link: '/',
  },
  {
    title: 'NYG vs. ATL',
    linkTitle: 'Sun, 9/26 vs. ATL',
    meta: ['Game 2', '09/26/2021'],
    imgSrc: 'https://img.granted.co/1620982189704-sqon-nft.jpg',
    packages: [
      {
        imgSrc: '/nft/jersey.png',
        title: 'THE JERSEY PACKAGE',
        link: 'https://granted.co/experiences/548-the-jersey-package-atl-vs-nyg',
      },
      {
        imgSrc: '/nft/cleat.png',
        title: 'THE CLEAT PACKAGE',
        link: 'https://granted.co/experiences/547-the-cleat-package-atl-vs-nyg',
      },
      {
        imgSrc: '/nft/football.png',
        title: 'THE FOOTBALL PACKAGE',
        link: 'https://granted.co/experiences/546-the-football-package-atl-vs-nyg',
      },
    ],
    link: '/',
  },
  {
    title: 'NYG vs. LAR',
    linkTitle: 'Sun, 10/17 vs. LAR',
    meta: ['Game 3', '10/17/2021'],
    imgSrc: 'https://img.granted.co/1620981497441-sqon-nft.jpg',
    packages: [
      {
        imgSrc: '/nft/jersey.png',
        title: 'THE JERSEY PACKAGE',
        link: 'https://granted.co/experiences/545-the-jersey-package-lar-vs-nyg',
      },
      {
        imgSrc: '/nft/cleat.png',
        title: 'THE CLEAT PACKAGE',
        link: 'https://granted.co/experiences/544-the-cleat-package-lar-vs-nyg',
      },
      {
        imgSrc: '/nft/football.png',
        title: 'THE FOOTBALL PACKAGE',
        link: 'https://granted.co/experiences/543-the-football-package-lar-vs-nyg',
      },
    ],
    link: '/',
  },
  {
    title: 'NYG vs. CAR',
    linkTitle: 'Sun, 10/24 vs. CAR',
    meta: ['Game 4', '10/24/2021'],
    imgSrc: 'https://img.granted.co/1620981538506-sqon-nft.jpg',
    packages: [
      {
        imgSrc: '/nft/jersey.png',
        title: 'THE JERSEY PACKAGE',
        link: 'https://granted.co/experiences/542-the-jersey-package-car-vs-nygs',
      },
      {
        imgSrc: '/nft/cleat.png',
        title: 'THE CLEAT PACKAGE',
        link: 'https://granted.co/experiences/541-the-cleat-package-car-vs-nyg',
      },
      {
        imgSrc: '/nft/football.png',
        title: 'THE FOOTBALL PACKAGE',
        link: 'https://granted.co/experiences/540-the-football-package-car-vs-nyg',
      },
    ],
    link: '/',
  },
  {
    title: 'NYG vs. LV',
    linkTitle: 'Sun, 11/7 vs. LV',
    meta: ['Game 5', '11/7/2021'],
    imgSrc: 'https://img.granted.co/1620981580799-sqon-nft.jpg',
    packages: [
      {
        imgSrc: '/nft/jersey.png',
        title: 'THE JERSEY PACKAGE',
        link: 'https://granted.co/experiences/539-the-jersey-package-lv-vs-nyg',
      },
      {
        imgSrc: '/nft/cleat.png',
        title: 'THE CLEAT PACKAGE',
        link: 'https://granted.co/experiences/538-the-cleat-package-lv-vs-nyg',
      },
      {
        imgSrc: '/nft/football.png',
        title: 'THE FOOTBALL PACKAGE',
        link: 'https://granted.co/experiences/537-the-football-package-lv-vs-nyg',
      },
    ],
    link: '/',
  },
  {
    title: 'NYG vs. PHI',
    linkTitle: 'Sun, 11/28 vs. PHI',
    meta: ['Game 6', '11/28/2021'],
    imgSrc: 'https://img.granted.co/1620981631345-sqon-nft.jpg',
    packages: [
      {
        imgSrc: '/nft/jersey.png',
        title: 'THE JERSEY PACKAGE',
        link: 'https://granted.co/experiences/536-the-jersey-package-phi-vs-nyg',
      },
      {
        imgSrc: '/nft/cleat.png',
        title: 'THE CLEAT PACKAGE',
        link: 'https://granted.co/experiences/535-the-cleat-package-phi-vs-nyg',
      },
      {
        imgSrc: '/nft/football.png',
        title: 'THE FOOTBALL PACKAGE',
        link: 'https://granted.co/experiences/534-the-football-package-phi-vs-nyg',
      },
    ],
    link: '/',
  },
  {
    title: 'NYG vs. DAL',
    linkTitle: 'Sun, 12/19 vs. DAL',
    meta: ['Game 7', '12/19/2021'],
    imgSrc: 'https://img.granted.co/1620981657039-sqon-nft.jpg',
    packages: [
      {
        imgSrc: '/nft/jersey.png',
        title: 'THE JERSEY PACKAGE',
        link: 'https://granted.co/experiences/533-the-jersey-package-dal-vs-nyg',
      },
      {
        imgSrc: '/nft/cleat.png',
        title: 'THE CLEAT PACKAGE',
        link: 'https://granted.co/experiences/532-the-cleat-package-dal-vs-nyg',
      },
      {
        imgSrc: '/nft/football.png',
        title: 'THE FOOTBALL PACKAGE',
        link: 'https://granted.co/experiences/531-the-football-package-dal-vs-nyg',
      },
    ],
    link: '/',
  },
  {
    title: 'NYG vs. WAS',
    linkTitle: 'Sun, 01/09 vs. WAS',
    meta: ['Game 8', '01/09/2022'],
    imgSrc: 'https://img.granted.co/1620981681154-sqon-nft.jpg',
    packages: [
      {
        imgSrc: '/nft/jersey.png',
        title: 'THE JERSEY PACKAGE',
        link: 'https://granted.co/experiences/530-the-jersey-package-was-vs-nyg',
      },
      {
        imgSrc: '/nft/cleat.png',
        title: 'THE CLEAT PACKAGE',
        link: 'https://granted.co/experiences/529-the-cleat-package-was-vs-nyg',
      },
      {
        imgSrc: '/nft/football.png',
        title: 'THE FOOTBALL PACKAGE',
        link: 'https://granted.co/experiences/528-the-football-package-game-8',
      },
    ],
    link: '/',
  },
]

export const cards = [
  {
    title: 'THE JERSEY PACKAGE',
    imgSrc: '/nft/jersey.png',
    list: [
      'Edition # 1/3 Saquon Barkley Rookie NFT digital art collectible (unique per home game)',
      '2 home game tickets',
      '2 field passes',
      '2 exclusive Saquon Barkley Meet & Greet passes',
      'Limited edition game-used, signed jersey from Saquon',
      'Personal Gameday Concierge, supplied by Confirmed360',
    ],
  },
  {
    title: 'THE CLEAT PACKAGE',
    imgSrc: '/nft/cleat.png',
    list: [
      'Edition # 2/3 Saquon Barkley Rookie NFT digital art collectible (unique per home game)',
      '2 home game tickets',
      '2 field passes',
      '2 exclusive Saquon Barkley Meet & Greet passes',
      'Limited edition game-used, signed cleats from Saquon',
      'Personal Gameday Concierge, supplied by Confirmed360',
    ],
  },
  {
    title: 'THE FOOTBALL PACKAGE',
    imgSrc: '/nft/football.png',
    list: [
      'Edition # 3/3 Saquon Barkley Rookie NFT digital art collectible (unique per home game)',
      '2 home game tickets',
      '2 field passes',
      '2 exclusive Saquon Barkley Meet & Greet passes',
      'Limited edition game-used, signed football from Saquon',
      'Personal Gameday Concierge, supplied by Confirmed360',
    ],
  },
]

export const legacyCards = [
  {
    title: 'The ember experience',
    imgSrc: '/nft/ember.png',
    list: [
      'A Leg Day Workout with Saquon Barkley',
      'The Limited Edition Ember 1/1 NFT digital art collectible',
    ],
    link: 'https://granted.co/experiences/527-ember-experience',
  },
  {
    title: 'The Inferno Experience',
    imgSrc: '/nft/inferno.png',
    list: [
      'A Lunch or Dinner with Saquon Barkley',
      'The Limited Edition Inferno 1/1 NFT digital art collectible',
    ],
    link: 'https://granted.co/experiences/526-inferno-experience',
  },
]
